import {
  LoadingScreen,
  LoadingScreenWrapper,
  ThemeProvider,
} from '@yarmill/component-library';
import { observer } from 'mobx-react-lite';
import { useIsLoggedIn } from '../auth/hooks';
import { useRootStore } from '@yarmill/utils';
import { PropsWithChildren, useEffect, useState } from 'react';
import { AsyncStatus } from '@yarmill/types';

export const AppLoader = observer(function AppLoader({
  children,
}: PropsWithChildren) {
  const isLoggedIn = useIsLoggedIn();
  const rootStore = useRootStore();
  const [showLoader, setShowLoader] = useState<boolean>(isLoggedIn);

  useEffect(() => {
    if (rootStore.isReady) {
      setShowLoader(false);
    }
    if (rootStore.status === AsyncStatus.rejected) {
      setShowLoader(false);
    }
  }, [rootStore.isReady, rootStore.status]);

  return (
    <>
      {children}
      <LoadingScreenWrapper $showLoader={showLoader}>
        <ThemeProvider theme="master">
          <LoadingScreen />
        </ThemeProvider>
      </LoadingScreenWrapper>
    </>
  );
});
